import {FeatureGate} from 'common/report/constants';
import {CurrentProject} from 'common/report/model-resources/projects';
import {ProjectDetails} from 'common/report/stores/project-details';

export function projectHasEventApprovalTurnedOn(currentProject?: CurrentProject | ProjectDetails) {
  return isEventApprovalFeatureEnabled(currentProject) && currentProject?.hasEventApprovalEnabled;
}

export function isEventApprovalFeatureEnabled(currentProject?: CurrentProject | ProjectDetails): boolean {
  if (!currentProject) {
    return false;
  }

  return currentProject.getFeatureGate(FeatureGate.EventApproval);
}
